// extracted by mini-css-extract-plugin
export default {"mainGrid":"mainGrid__UGhPK","section":"section__2CGZZ"};